import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TextEditorComponent } from './text-editor.component';


import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { CustomFlexLayoutModule } from '../flex-layout/custom-flex-layout.module';
import { DocEditorModule } from '../doc-editor/doc-editor.module';
//import { AngularEditorModule } from 'src/app/global/editor/angular-editor.module';
@NgModule({
  declarations: [
    TextEditorComponent
  ],
  imports: [
    CommonModule,
  
    FormsModule,
    ReactiveFormsModule,
    CustomFlexLayoutModule,
    MatDialogModule,
    MatIconModule,
    MatToolbarModule,
    MatButtonModule,
    DocEditorModule,
  ]
})
export class TextEditorModule { }
